import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add'
import Badge from '@material-ui/core/Badge'
import Button from '@material-ui/core/Button'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckIcon from '@material-ui/icons/Check'
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye'
import Editor, { Editable, createEmptyState } from 'ory-editor-core'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import NewLecture from './newlecture'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import BrowserDetection from 'react-browser-detection'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import './lecture.css'

// const swal = withReactContent(Swal)

const actionbutton = {
  position :'absolute',
  bottom: '23px',
  right: '20px'
}

const checkstyle = {
  color : '#00b600',
  fontSize : '37px'
}

const liststyle = {
  maxWidth : '600px',
  minHeight : '300px',
  marginLeft : 'auto',
  marginRight : 'auto'
}

// Stile für die farbliche Kennzeichnung
const unterweisungStyle = {
  borderLeft: '4px solid #2196F3', // Blau für Unterweisungen
  backgroundColor: '#E3F2FD'
}

const fortbildungStyle = {
  borderLeft: '4px solid #4CAF50', // Grün für Fortbildungen
  backgroundColor: '#E8F5E8'
}

const detectedBrowser = {
  ie: () => (<div className="iewarning">Seite Nicht Internet-Explorer tauglich. Bitte benutze einen anderen Browser (z.B. Chrome, Edge, Firefox)</div>),
default: () => <div></div>
}

class ListLectures extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      lectures : false,
      tab:0,
      openNewDialog : false,
      qualifications: [],
    }

  }

  componentDidMount () {
    if (this.props.socket) {
     let s = this.props.socket
     s.on('lectures', data => {
       this.setState({lectures : data})
     })
     s.on('lectures2', data => {
       this.setState({lectures2 : data})
     })
     s.emit('get distinct qualifications',data => {
         this.setState({qualifications:data})
     })
     s.emit('get lectures')
    }
}

createNewLecture = ({title,editor,qualifications}) => {
  let s = this.props.socket
  let data = {
    name : title,
    author : this.props.userdata.name,
    manage : this.props.userdata.manage,
    editor: editor,
    qualifications: qualifications,
  }
  s.emit('create new lecture',data)
  this.setState({openNewDialog : false})

}

 editLecture = (e,id) => {
   console.log(id)
 }

 handleTabChange = (event, tab) => {
  this.setState({ tab });
 };

 openStatsPage = (e,lid) => {
   e.preventDefault()
   console.log(e)
   this.props.history.push('/stats/'+lid)
 }

  render () {

    const llist = (
      this.state.lectures && this.state.lectures.map((l,i) => (
        <div key={'listL'+i}>
        {this.props.viewstats && false &&
          <Link to={"/lectureresults/"+l.id} style={{ textDecoration: 'none' }}>
          <Button >
          <RemoveRedEyeIcon />
          </Button>
          </Link>
        }
        <Link to={"/lecture/"+l.id} style={{ textDecoration: 'none' }}>
        <ListItem key={i}>
        {l.passed && <CheckIcon style={checkstyle}/>}
        <ListItemText primary={l.name} className={l.hidden ? 'graylistentry' : 'blacklistentry'}/>
        {(this.props.viewstats || l.writepermission ) &&
          <Badge color="primary"  badgeContent={(<div onClick={e => this.openStatsPage(e,l.id)} className='badgecircle'>{l.passed_count}</div>)}>
        <ListItemSecondaryAction>
        {(this.props.ismanager || l.writepermission) &&
        <Link to={"/editlecture/"+l.id} style={{ textDecoration: 'none' }}>
          <Button >
            <EditIcon />
          </Button>
        </Link>
        }
      </ListItemSecondaryAction>      
      </Badge>
      }
        </ListItem>
        </Link>
        <Divider/>
        </div>
      ))
    )

    const llist2 = (
      this.state.lectures2 && this.state.lectures2.map((l,i) => (
        <div key={'listL'+i}>
        {this.props.viewstats && false &&
          <Link to={"/lectureresults/"+l.id} style={{ textDecoration: 'none' }}>
          <Button >
          <RemoveRedEyeIcon />
          </Button>
          </Link>
        }
        <Link to={"/lecture/"+l.id} style={{ textDecoration: 'none' }}>
        <ListItem key={i}>
        {l.passed && <CheckIcon style={checkstyle}/>}
        <ListItemText primary={l.name} className={l.hidden ? 'graylistentry' : 'blacklistentry'}/>
        {(this.props.viewstats || l.writepermission ) &&
          <Badge color="primary"  badgeContent={(<div onClick={e => this.openStatsPage(e,l.id)} className='badgecircle'>{l.passed_count}</div>)}>
        <ListItemSecondaryAction>
        {(this.props.ismanager || l.writepermission ) &&
        <Link to={"/editlecture/"+l.id} style={{ textDecoration: 'none' }}>
          <Button >
            <EditIcon />
          </Button>
        </Link>
      }
      </ListItemSecondaryAction>
      </Badge>
    }
        </ListItem>
        </Link>
        <Divider/>
        </div>
      ))
    )


  return (

    <div>
    <BrowserDetection>
    {detectedBrowser}
    </BrowserDetection>
    <Paper style={liststyle}>
    <Tabs
      value={this.state.tab}
      onChange={this.handleTabChange}
      indicatorColor="primary"
      textColor="primary"
      variant = "fullWidth"
      aria-label="full width tabs example">
      <Tab label="Unterweisungen" id={0}/>
      <Tab label="Fortbildungen" id={1} />
    </Tabs>
    <SwipeableViews index={this.state.tab} >
    <div>
    <List>
    {llist}
    </List>
    </div>
    <div>
    <List>
    {llist2}
    </List>
    </div>
    </SwipeableViews>
    </Paper>
    {this.props.ismanager &&
    <div>
    <Button variant="fab" color="secondary" style={actionbutton} onClick={(event) => this.setState({openNewDialog : true})}>
      <AddIcon/>
      </Button>
    <NewLecture onClose={e => this.setState({openNewDialog : false})} open={this.state.openNewDialog} 
    qlist={this.state.qualifications} createNewLecture={this.createNewLecture} />
    </div>
    }
    </div>
  )}
}




export default withRouter(ListLectures)
